module.exports = __webpack_public_path__ + "img/upload.d7e4d19f.svg";